import { Injectable } from '@angular/core';
import { BaseViewModel } from '../../ui-ndms/view-models/base.view-model';

@Injectable()
export class ViewModelModelMappingService {

  constructor() { }

  toApiModel<viewModel extends BaseViewModel, apiModel>(source: viewModel, destination: apiModel): apiModel {
    return Object.assign({}, destination, source);
  }

  fromApiModel<apiModel, viewModel extends BaseViewModel>(destination: viewModel, source?: apiModel): viewModel {
    //return <viewModel><any>Object.assign(destination, source);
    Object.keys(destination).forEach(key => {
      if (destination[key] instanceof BaseViewModel) {
        let destinationProp = destination[key];
        let sourceProp = source![key];

        if (sourceProp) {
          this.fromApiModel<typeof sourceProp, typeof destinationProp>(destinationProp, sourceProp);
        }
      }
      else {
        if(source![key])
          destination[key] = source![key];
      }
    });
    return destination;
  }

}
